import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'mrh_details.my_offers.title',
  },
  subTitle: {
    id: 'mrh_details.my_offers.sub_title',
  },
  body: {
    id: 'mrh_details.my_offers.body',
  },
  action: {
    id: 'mrh_details.my_offers.action',
  },
});
